import {gql} from 'apollo-boost';

export const GET_USER = gql`
  query getUser($id: ID!){
    getUser(
      id: $id
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
      isDisabled
    }
  }
`;

export const GET_USERS = gql`
  query {
    getUsers {
      id
      photo
      prefix
      name
      surname
      email
      userType
      isDisabled
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query {
    getCurrentUser {
      id
      uuid
      userGroup {
        id
        code
        nameLocal
        nameEng
      }
      photo
      code
      userLogin
      nameLocal
      surnameLocal
      nameEng
      surnameLocal
      email
      isActive
      isOnline
      lastChangePasswordDate
      lastLoginDate
      lastLogOutDate
      accessFailedCount
      profile
      meta
    }
  }
`;

export const ADD_USER = gql`
  mutation addUser($payload: UserInput!) {
    addUser(
      payload: $payload
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
      isDisabled
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($id: ID!, $payload: UserInput!) {
    updateUser(
      id: $id,
      payload: $payload
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
      isDisabled
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(
      id: $id
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
      isDisabled
    }
  }
`;

export const CURRENT = gql`
  query {
    getCurrentUser {
      id
      photo
      prefix
      name
      surname
      email
      userType
    }
  }
`;

export const LOGIN = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(
      email: $email,
      password: $password
    ) {
      token
      user {
        id
        photo
        prefix
        name
        surname
        email
        userType
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(
      email: $email
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($resetPasswordCode: String!, $newPassword: String!) {
    resetPassword(
      resetPasswordCode: $resetPasswordCode
      newPassword: $newPassword
    ) {
      id
      photo
      prefix
      name
      surname
      email
      userType
    }
  }
`;

export const RESET_PASSWORD_CURRENT_USER = gql`
  mutation resetPasswordCurrentUser($oldPassword: String!, $newPassword: String!) {
    resetPasswordCurrentUser(
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      error
      message
    }
  }
`;

export const SIGN_OUT = gql`
  mutation signOut {
    signOut
  }
`;

export const REGISTER = gql`
  mutation signUp($name: String!, $surname: String!, $email: String!, $password: String!) {
    signUp(
      name: $name
      surname: $surname
      email: $email
      password: $password
    ) {
      token
      user {
        id
        photo
        prefix
        name
        surname
        email
        userType
      }
    }
  }
`;
//
// export const FIND_USER_FROM_EMAIL = gql`
//   query findUserFromEmail($email: String!) {
//     findUserFromEmail(
//       email: $email
//     ) {
//       id
//       email
//       photo
//       prefix
//       name
//       surname
//       userType
//     }
//   }
// `;
export const GET_USER_PROFILE_SHARING_URL_ONCE = gql`
  query getUserProfileSharingUrlOnce($mode: String)
  {
    getUserProfileSharingUrlOnce(
      mode: $mode
    )
  }
`;

export const GET_USER_PUBLIC_PROFILE = gql`
  query getUserPublicProfile($userUUID: String!) {
    getUserPublicProfile(
      userUUID: $userUUID
    ) {
      nameLocal
      surnameLocal
      nameEng
      surnameEng
      isActive
      photo
    }
  }
`;
